// SPDX-License-Identifier: AGPL-3.0-or-later
import {Endpoints} from '@app/features/app/constants/Endpoints';
import {conduit} from '@app/features/platform/transport/RestTransport';
import {Logger} from '@app/features/platform/utils/AppLogger';

const logger = new Logger('AgeVerification');

interface AgeVerificationSession {
	url: string;
}

async function requestVerificationSession(): Promise<AgeVerificationSession> {
	const response = await conduit.post<AgeVerificationSession>(Endpoints.AGE_VERIFICATION);
	return response.body;
}

function sessionUrlFrom(response: AgeVerificationSession): string {
	return response.url;
}

function rethrowSessionFailure(error: unknown): never {
	logger.error('Age verification session creation failed', error);
	throw error;
}

export async function createVerificationSession(): Promise<string> {
	try {
		const session = await requestVerificationSession();
		logger.info('Age verification session created');
		return sessionUrlFrom(session);
	} catch (error) {
		rethrowSessionFailure(error);
	}
}
